import { hideTransactionDetailModal, setTransactionDetail } from 'actions/reports/transactions'
import { setReceiptInvoices, hideReceiptInvoice } from 'actions/reports/invoices'
import SidebarMokaLogo from './SidebarMokaLogo'
import SubSidebar from 'components/SubSidebar'
import { Link } from 'react-router'
import {shouldShowEmployeeManagement, shouldShowSalesTypeLibrary, shouldShowPromoLibrary, shouldShowTableManagement} from 'utils/ftue'
import {logout} from 'actions'
import _ from 'lodash'
import styles from './style.css'
import * as mixpanelZendesk from 'mixpanel/zendeskLinks'
import {isFullSiteMode} from 'utils/fullSite'

function parseActiveSidebarFromPath (path) {
  const chunks = path.split('/')

  function isAccountSettingSidebar (chunks) {
    return chunks.length && chunks[1] === 'settings' || (chunks[1] === 'outlets')
  }

  let deduceSelectedNavFromUrl = path.split('/')[1].replace(/-/g, ' ')

  return isAccountSettingSidebar(chunks) ? 'account settings' : deduceSelectedNavFromUrl
}

class Sidebar extends React.Component {
  constructor (props) {
    super(props)
    let {location} = props
    const path = location.pathname

    this.state = {
      activeSidebarName: parseActiveSidebarFromPath(path)
    }
    this._setActiveSidebarName = this._setActiveSidebarName.bind(this)
  }

  componentWillReceiveProps (nextProps, nextState) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setState({
        activeSidebarName: parseActiveSidebarFromPath(nextProps.location.pathname)
      })
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (this.props.loggedIn !== nextProps.loggedIn) {
      return true
    }
    if (this.props.location.pathname !== nextProps.location.pathname) {
      return true
    }

    let { user } = this.props
    let nextUser = nextProps.user
    if (user || nextUser) {
      if (user.first_name !== nextUser.first_name) {
        return true
      }
      if (user.last_name !== nextUser.last_name) {
        return true
      }
      if (user.email !== nextUser.last_name) {
        return true
      }
    }
    return false
  }

  render () {
    let { subMenuOf, user } = this.props
    let backOfficemenus = _.filter(subMenuOf, function (o) { return o[0].access === 'Back-office' })
    let menuHashes = _.map(backOfficemenus, (bom) => ({ menu: bom[0].menu, priority_rank: bom[0].priority_rank }))
    let sortedHashesMenu = _.sortBy(menuHashes, mH => mH.priority_rank)
    let menus = _.map(sortedHashesMenu, (bom) => bom.menu)
    let sideBarMenus = menus.map(function (menu) {
      if (subMenuOf[menu.toLowerCase()].length > 1) {
        if ((menu.toLowerCase() === 'table management') && isFullSiteMode()) {
          return null
        }

        return subMenuOf[menu.toLowerCase()] && this._getSidebarWithSub(menu.toLowerCase())
      } else {
        return subMenuOf[menu.toLowerCase()] && this._getSidebarWithoutSub(menu.toLowerCase())
      }
    }, this)

    return (
      <div>
        <nav className='navbar navbar-inverse navbar-fixed-top' id='sidebar-wrapper' role='navigation'>
          <ul className='nav sidebar-nav'>
            <SidebarMokaLogo link={this._mokaLogoLink()} />
            <li className='dropdown account-info'>
              <a href='javascript:void(0)' className='dropdown-toggle' data-toggle='dropdown' onClick={(e) => this._setActiveSidebarName(null)}>
                <span className={`${styles['business-name']}`}>{user.first_name} {user.last_name}</span>
                <span className='glyphicon glyphicon-chevron-right account-info' />
                <br />
              </a>
              <ul className='dropdown-menu'>
                <li>
                  <div className='content-account-info'>
                    <div className='avatar col-md-4'>
                      {
                        user.gravatar
                          ? <img src={user.gravatar} alt='account profile default' width='100%' />
                          : <img src={require('assets/images/account-profile-default.jpg')} alt='account profile default' width='100%' />
                      }
                    </div>
                    <div className='mk-business-info col-md-8'>
                      <div className='business-name gt'><Link to='/settings/public_profile'>{user.business.name}</Link></div>
                      <div className='business-email'>{user.email}</div>
                    </div>
                    <hr />
                    <div className='logout col-md-12'>
                      <div className='logout-link'>
                        <Link to='#' onClick={this._logout}><i className='fa fa-sign-out' />&nbsp;&nbsp;Sign Out</Link>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
            {sideBarMenus}
          </ul>
        </nav>
        <div className='footer-sidebar'>
          <div className='knowledge-center'>
            <span className='glyphicon glyphicon-info-sign' />
            <Link
              to='https://mokaposhelp.zendesk.com/hc/en-us'
              target='_blank'
              onClick={this._onClickKnowledge}>
              Knowledge Center
            </Link>
          </div>
          <div className='clear' />
          <div className='phone'>
            <span className='fa fa-phone-square' />
            <span className={`${styles['footer-phone-number']}`}>021-50303717 / 1500970</span>
          </div>
        </div>
      </div>
    )
  }

  _onClickKnowledge = () => {
    mixpanelZendesk.knowledgeCenterStart()
  }

  _onChangeOutlet (outletIds, pathname) {
  }

  _onClickHamburgerButton = () => {
    this.props.dispatch(setTransactionDetail(null))
    this.props.dispatch(hideTransactionDetailModal())
    this.props.dispatch(setReceiptInvoices(null))
    this.props.dispatch(hideReceiptInvoice(true))
  }

  _mokaLogoLink = () => {
    const {user} = this.props
    if (user) {
      if (user.is_owner || user.is_manager) {
        return '/dashboard'
      } else {
        return '/settings/accounts'
      }
    } else {
      return '/login'
    }
  }

  _getSubSidebar = (menu) => {
    let subMenuName = menu.sub_menu
    let url = menu.urls[0]
    let {location} = this.props
    const path = location.pathname

    return (
      <li>
        <Link
          className={menu.urls.includes(path) ? 'active' : ''}
          to={url}>
          {subMenuName}
        </Link>
      </li>
    )
  }

  _setActiveSidebarName = (name) => {
    this.setState(({
      activeSidebarName: name
    }), () => { this.forceUpdate() })
  }

  _getSidebarWithSub = (name) => {
    let {location, subMenuOf} = this.props
    let urls = []
    subMenuOf[name].forEach(function (menu) {
      menu.urls.forEach(function (url) {
        urls.push(url)
      })
    })
    const path = location.pathname
    const firstSubSidebar = this._getFirstSubSidebar(subMenuOf[name])
    let newLabel = false

    if (firstSubSidebar.startsWith('/employees') && shouldShowEmployeeManagement()) {
      newLabel = true
    } else if (firstSubSidebar.startsWith('/library') && shouldShowSalesTypeLibrary()) {
      newLabel = true
    } else if (firstSubSidebar.startsWith('/library') && shouldShowPromoLibrary()) {
      newLabel = true
    } else if (firstSubSidebar.startsWith('/table-management') && shouldShowTableManagement()) {
      newLabel = true
    }

    return (
      <li key={name} className={`dropdown ${this._isOpen(name) ? 'open' : ''} ${name}`}>
        <a href='javascript:void(0)'
          className={`dropdown-toggle has-child ${urls.includes(path) ? 'active' : ''}`}
          onClick={() => { this._setActiveSidebarName(this._isOpen(name) ? '' : name) }}
        >
          <span className='glyphicon glyphicon-chevron-right' /> {name} {newLabel && <span className='new-label'>NEW</span>}
        </a>
        <SubSidebar
          links={this._toLinks(subMenuOf[name])}
          location={location}
          user={this.props.user}
          subscriptionExpired={this.props.data.subscriptionExpired}
        />
      </li>
    )
  }

  _getSidebarWithoutSub = (name) => {
    let {location, subMenuOf} = this.props
    const path = location.pathname
    const firstSubSidebar = this._getFirstSubSidebar(subMenuOf[name])
    let newLabel = false
    if (firstSubSidebar.startsWith('/employees') && shouldShowEmployeeManagement()) {
      newLabel = true
    }

    return (
      <li onClick={(e) => this._setActiveSidebarName(name)}>
        <Link
          className={path.startsWith(`/${name}`) || path === '/' ? 'active' : ''}
          to={firstSubSidebar}
        >
          {name} {newLabel && <span className='new-label'>NEW</span> }
        </Link>
      </li>
    )
  }

  _getFirstSubSidebar = (permissions) => {
    return _.orderBy(permissions, 'priority_rank')[0].urls[0]
  }

  _logout = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.props.dispatch(logout())
  }

  _toLinks = (subMenus) => {
    let links = []
    let sortedSubMenu = _.orderBy(subMenus, 'priority_rank')
    for (let i = 0; i < sortedSubMenu.length; i++) {
      const subMenu = sortedSubMenu[i]
      links.push({
        href: subMenu.urls[0],
        label: subMenu.sub_menu,
        urls: subMenu.urls
      })
    }
    return links
  }

  _isOpen = (name) => {
    return name === this.state.activeSidebarName
  }
}

Sidebar.propTypes = {
  loggedIn: React.PropTypes.bool,
  currentlySending: React.PropTypes.bool,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array
}

export default Sidebar



// WEBPACK FOOTER //
// ./app/components/Sidebar/Sidebar.js